/**
 * Fire-and-forget SDK trade attribution.
 *
 * Reports the initiated transaction hash of every submission that targets the
 * Trading contract to `{builderApiUrl}/v1/trade`. Runs entirely in the
 * background: the request is never awaited and every failure is swallowed, so
 * it can never affect trading latency or behavior.
 */
export function reportTradeSubmission(builderApiUrl: string, hash: string): void {
  try {
    void fetch(`${builderApiUrl}/v1/trade`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ hash }),
      signal: typeof AbortSignal.timeout === 'function' ? AbortSignal.timeout(10_000) : undefined,
    }).catch(() => undefined);
  } catch {
    // Attribution must never throw into the trading path.
  }
}
